var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-carousel',{attrs:{"interval":500000,"height":"390px","arrow":"always"}},_vm._l((_vm.noticias),function(item){return _c('el-carousel-item',{key:item.Id},[_c('el-col',{staticClass:"cardContainer",attrs:{"span":24}},[_c('NoticiaCard',{attrs:{"noticia":item}})],1)],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }